import React from "react";
import { useSelector } from "react-redux";
import Footers from "../../Footers/Footers";
import FooterUnit from "../../Footers/FooterUnit";
import Headers from "../../Headers/Headers";
import { unitSelector } from "../../../redux/unit.slice";
import { isPastAuctionUnit } from "../../../utils/auction";
// import Helper from '../helper';

const DetailUnitLayout = (props) => {
  const { children } = props;
  const unit = useSelector(unitSelector);

  // Hide footer if unit status is SOLD, PAID, RELEASED, RETURNED, or WANPRESTASI,
  // atau jika unit berasal dari lelang yang sudah selesai (halaman "Unit Tidak Tersedia").
  const isHiddenByStatus =
    unit?.unit_status === "SOLD" ||
    unit?.unit_status === "PAID" ||
    unit?.unit_status === "RELEASED" ||
    unit?.unit_status === "RETURNED" ||
    unit?.unit_status === "WANPRESTASI";
  const shouldHideFooter = isHiddenByStatus || isPastAuctionUnit(unit);

  return (
    <>
      <div className={`position-relative ${!shouldHideFooter && "main-container"}`}>
        <Headers />
        <div className="unit-image h-100 w-100 main-content" style={{ minHeight: "calc(100vh - 4rem)" }}>
          {children}
        </div>
        <Footers />
      </div>
      {!shouldHideFooter && <FooterUnit />}
      {/* <Helper /> */}
    </>
  );
};

export default DetailUnitLayout;
